//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import UMUM from  '../../library/umum'


export default {
  data() {
    return {
      listData: [],
      listKegiatan : [],

      kegiatan : null,
      loadData : true,


      UMUM : UMUM
    };
  },
  methods: {
    getKegiatan(){
      fetch(this.$store.state.url.URL_CNT_KEGIATAN_TERBARU + "list5", {
          method: "GET",
          headers: {
          "content-type": "application/json",
          }
      })
          .then(res => res.json())
          .then(res_data => {
              this.listKegiatan = res_data
              // console.log(res_data);
      });
    },

    getKegiatanOne(){
      this.loadData = true;
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_CNT_DESA_PERPUSTAKAAN_KEG + "getOne", {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            id : this.$route.query.KegiatanperpusId
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.kegiatan = res_data
              console.log(res_data);
              this.loadData = false;
              this.$store.commit("hideLoading");
      });
    },




  },
  mounted() {
    this.getKegiatan();
    this.getKegiatanOne();
  },
};
